import {ErrorResponse} from "../types/errors-response";
import {UseFormSetError} from "react-hook-form";

export  const errorsExtractor = (body: ErrorResponse, setError: UseFormSetError<any>): void => {
  if (Array.isArray(body.details) && body.details.length > 0) {
    body.details.forEach(({ field, errors }) => {
      if (field) {
        setError(field, {
          type: 'server',
          message: errors?.[0] || body.message,
        });
      }
    });
  }
}
